import factory from '../requestFactory';

export default ({patient,phone,birthday}) => {
    return factory()
        .post('/patient/check-birthday', {
            patient_id:patient,
            phone:phone,
            birthday:birthday,
        });
}
